import { BranchProvider } from "../contexts/BranchContext";
import { CartProvider } from "../contexts/CartContext";
import { StorefrontProvider } from "../contexts/StorefrontContext";
import { ToastProvider } from "../contexts/ToastContext";

export function AppProviders({ children }: { children: React.ReactNode }) {
  return (
    <ToastProvider>
      <StorefrontProvider>
        <BranchProvider>
          <CartProvider>{children}</CartProvider>
        </BranchProvider>
      </StorefrontProvider>
    </ToastProvider>
  );
}
